import { render } from "./StatisticsMessage.vue?vue&type=template&id=31cf4e3a&scoped=true"
import script from "./StatisticsMessage.vue?vue&type=script&lang=js"
export * from "./StatisticsMessage.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-31cf4e3a"

export default script